import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import { useAppDispatch, useAppSelector } from '../../app/hooks.js';
import { selectColorMode } from '../../store/selectors/index.js';
import { colorModeToggled, drawerToggled } from '../../store/slices/uiSlice.js';
import Wordmark from './Wordmark.js';

export default function AppHeader() {
  const dispatch = useAppDispatch();
  const mode = useAppSelector(selectColorMode);

  return (
    <AppBar
      position="static"
      color="default"
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        backgroundImage: 'none',
        // Above the drawer so the wordmark and controls stay reachable while
        // the compact panel is open.
        zIndex: (t) => t.zIndex.drawer + 1,
      }}
    >
      {/* WCAG 2.4.1: keyboard users must be able to reach the map without
          tabbing through the entire catalog tree. */}
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: 'absolute',
          left: 8,
          top: 8,
          px: 2,
          py: 1,
          zIndex: 'tooltip',
          borderRadius: 1,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          transform: 'translateY(-200%)',
          '&:focus': { transform: 'translateY(0)' },
        }}
      >
        Skip to map
      </Box>

      <Toolbar variant="dense" sx={{ gap: 1 }}>
        <Tooltip title="Toggle panel">
          <IconButton
            edge="start"
            size="small"
            onClick={() => dispatch(drawerToggled())}
            aria-label="Toggle data panel"
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Wordmark />

        <Box sx={{ flex: 1 }} />

        <Tooltip title={mode === 'dark' ? 'Light theme' : 'Dark theme'}>
          <IconButton
            size="small"
            onClick={() => dispatch(colorModeToggled())}
            aria-label={mode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          >
            {mode === 'dark' ? (
              <LightModeOutlined fontSize="small" />
            ) : (
              <DarkModeOutlined fontSize="small" />
            )}
          </IconButton>
        </Tooltip>

        {/*
          Stubbed deliberately. The upstream login exists but currently 404s, and
          nothing in this prototype needs an account. Wiring it would mean
          holding credentials for a system we do not operate.
        */}
        <Tooltip title="Accounts are not part of this prototype">
          <span>
            <Button size="small" variant="outlined" disabled>
              Sign in
            </Button>
          </span>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
}
